import React, { useState } from 'react';
import {
  Box,
  Collapse,
  IconButton,
  Stack,
  Typography,
  Button,
  Paper,
  Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IServiceDraft } from '../../../../store/reducers/createService';
import { i18n } from '../../../../translate/i18n';

interface Props {
  openModal: () => void;
}

const DraftList: React.FC<Props> = ({ openModal }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#EEF7EC",
        borderRadius: 2,
        padding: "16px 20px",
        gap: 2,
        marginBottom: '20px',
      }}
    >
      {/* Left content */}
      <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
        <InfoOutlinedIcon color='primary' sx={{ mt: "2px" }} />

        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "#2E7D32" }}
          >
            {i18n.t("createService.draftListTitle") as string}
          </Typography>

          <Typography variant="body2" sx={{ color: "#2E7D32" }}>
            {i18n.t("createService.draftListDescription") as string}
          </Typography>
        </Box>
      </Box>

      {/* Action */}
      <Button
        variant="outlined"
        sx={{
          color: "#2E7D32",
          borderColor: "#A5D6A7",
          fontWeight: 600,
          paddingX: 3,
          "&:hover": {
            borderColor: "#2E7D32",
            backgroundColor: "rgba(46, 125, 50, 0.04)",
          },
        }}
        onClick={openModal}
      >
        {i18n.t("createService.draftListButton") as string}
      </Button>
    </Box>
  );
}

export default DraftList;